import {Handler} from '../../libs/shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../libs/shared/helpers/src/types/asyncStatuses';

export type AsyncData<T, E extends Error = Error> =
  | {
      status: AsyncStatusesEnum.LOADING;
    }
  | {
      status: AsyncStatusesEnum.LOADED;
      data: T;
    }
  | {
      status: AsyncStatusesEnum.FAILED;
      error: E;
    };

export function asyncDataLoading<T>(): AsyncData<T> {
  return {
    status: AsyncStatusesEnum.LOADING,
  };
}

export function asyncDataLoaded<T>(data: T): AsyncData<T> {
  return {
    status: AsyncStatusesEnum.LOADED,
    data,
  };
}

export function asyncDataFailed<T>(error: Error): AsyncData<T> {
  return {
    status: AsyncStatusesEnum.FAILED,
    error,
  };
}

export type AsyncDataWithRetry<T, E extends Error = Error> = AsyncData<T, E> & {onRetry: Handler};

export function makeAsyncDataWithRetry<T, E extends Error>(
  data: T | null | undefined,
  error: E | null | undefined,
  onRetry: Handler,
): AsyncDataWithRetry<T, E> {
  if (error) {
    return {status: AsyncStatusesEnum.FAILED, error, onRetry};
  }
  if (data) {
    return {status: AsyncStatusesEnum.LOADED, data, onRetry};
  }
  return {status: AsyncStatusesEnum.LOADING, onRetry};
}
